import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PipelineNav from './PipelineNav';
import AWSOnboarding from './AWSOnboarding';
import RequirementsStage from './stages/RequirementsStage';
import DesignStage       from './stages/DesignStage';
import DocsStage         from './stages/DocsStage';
import CodeStage         from './stages/CodeStage';
import TestsStage        from './stages/TestsStage';
import CICDStage         from './stages/CICDStage';
import DeployStage       from './stages/DeployStage';
import {
  getProject, clearProject, subscribe,
  getAwsConfig, clearAwsConfig,
} from '../../services/pipelineProject.service';
import './Pipeline.css';

function PipelineWorkspace() {
  const [project, setProject] = useState(getProject());
  const [awsReady, setAwsReady] = useState(Boolean(getAwsConfig()));
  const location = useLocation();

  useEffect(() => subscribe(setProject), []);

  const currentStageId = location.pathname.split('/').pop();

  const handleReset = () => {
    if (window.confirm('Reset the pipeline? All generated content will be lost.')) {
      clearProject();
      setProject(getProject());
    }
  };

  const handleResetAll = () => {
    if (window.confirm('Reset pipeline AND AWS settings?')) {
      clearProject();
      clearAwsConfig();
      setProject(getProject());
      setAwsReady(false);
    }
  };

  return (
    <div className="pipeline-workspace">
      {/* ── Stepper navigation ──────────────────────────────────────── */}
      <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', background: '#fff' }}>
        <PipelineNav project={project} currentStageId={currentStageId} />
        <div style={{ marginLeft: 'auto', marginRight: 16, display: 'flex', gap: 8, flexShrink: 0 }}>
          <button
            onClick={handleReset}
            style={{ padding: '6px 12px', fontSize: '0.78rem', border: '1px solid #e2e8f0', borderRadius: 6, background: 'transparent', color: '#64748b', cursor: 'pointer' }}
            title="Clear pipeline content (keep AWS settings)"
          >
            ↺ Reset Pipeline
          </button>
          <button
            onClick={handleResetAll}
            style={{ padding: '6px 12px', fontSize: '0.78rem', border: '1px solid #fecaca', borderRadius: 6, background: 'transparent', color: '#dc2626', cursor: 'pointer' }}
            title="Clear pipeline and AWS settings"
          >
            ⚙️ Reset All
          </button>
        </div>
      </div>

      {/* ── AWS Onboarding gate ─────────────────────────────────────── */}
      <div style={{ padding: '0 24px' }}>
        <AWSOnboarding onReady={(cfg) => setAwsReady(Boolean(cfg))} />
      </div>

      {/* ── Stage routes ─────────────────────────────────────────────── */}
      {awsReady && (
        <Routes>
          <Route index element={<Navigate to="requirements" replace />} />
          <Route path="requirements" element={<RequirementsStage />} />
          <Route path="design"       element={<DesignStage />} />
          <Route path="docs"         element={<DocsStage />} />
          <Route path="code"         element={<CodeStage />} />
          <Route path="tests"        element={<TestsStage />} />
          <Route path="cicd"         element={<CICDStage />} />
          <Route path="deployment"   element={<DeployStage />} />
          <Route path="*"            element={<Navigate to="requirements" replace />} />
        </Routes>
      )}
      {!awsReady && (
        <div style={{ padding: '40px 24px', textAlign: 'center', color: '#94a3b8', fontSize: '0.9rem' }}>
          ☝️ Fill in your AWS environment details above to start the pipeline.
        </div>
      )}
    </div>
  );
}

export default PipelineWorkspace;
